import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TLeadReferal } from '@src/shared/types/lead-referal';

export function LeadReferalFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TLeadReferal>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
    >
      {item.name}
    </FilterOptionItem>
  );
}
